// Google API Key - can be set via environment variable during build
const GOOGLE_API_KEY = 'AIzaSyCkA8SJxTpOQTymRf1Lfp1iyYE725M3SAs';

// Default API base URL (used as fallback if no runtime config is provided)
// const DEFAULT_API_BASE_URL = 'https://tcm-chatbot-api.azurewebsites.net/api/v1';
const DEFAULT_API_BASE_URL = 'https://dev-2.api.quebotia.com/api/v1';

// Default base online page URL (used as fallback if no runtime config is provided)
const DEFAULT_BASE_ONLINE_PAGE = 'https://yellow-pebble-0d33cd20f.6.azurestaticapps.net/tcm-page';

// Helper function to get the API base URL with runtime override support
const getApiBaseUrl = (runtimeUrl) => {
  // Priority: runtime config from calling script > default fallback
  return runtimeUrl || DEFAULT_API_BASE_URL;
};

// Helper function to get the base online page URL with runtime override support
const getBaseOnlinePage = (runtimeUrl) => {
  // Priority: runtime config from calling script > default fallback
  return runtimeUrl || DEFAULT_BASE_ONLINE_PAGE;
};

export { GOOGLE_API_KEY, getApiBaseUrl, getBaseOnlinePage };
